/**
 * El rótulo de un grupo de modificadores tal como lo ve el cliente.
 *
 * `name` es el nombre interno — el formulario de admin lo rotula literalmente
 * "Solo visible en admin" — y sirve para que el dueño encuentre el grupo en su
 * lista ("Proteína Adicional Cachapa"). `display_name` es el texto que escribió
 * para presentárselo a quien ordena ("Adicionar proteína (opcional)").
 *
 * El POS y el KDS ya leían `display_name`; la tienda online y el kiosko leían
 * `name` y le mostraban al cliente el rótulo interno. Esta función es la regla
 * única para las cuatro superficies.
 */
export function modifierGroupLabel(group: {
  name: string
  display_name?: string | null
}): string {
  const display = group.display_name?.trim()
  return display ? display : group.name
}
